var exports = {
  "S": "x43aef4ae--e86bd7--markers",
};

module.exports = exports;
